(() => {
  if (window.vvHighVariantPicker) return;
  window.vvHighVariantPicker = true;
  const requests = new WeakMap();
  // Keep Shopify's option-value IDs as the source of truth for the four-piece set.
  function enhanceOffDuty(scope = document) {
    scope.querySelectorAll('[data-vv-high-variant][data-vv-off-duty]').forEach(root => {
      const picker = root.querySelector('[data-vv-option-picker]');
      if (!picker || picker.querySelector('[data-vv-component-size]')) return;
      const combined = picker.querySelector('[data-vv-option]');
      if (!combined) return;
      const pairs = Array.from(combined.options).map(option => {
        const match = option.textContent.match(/^Robe:\s*(.*?)\s*\/\s*Slippers:\s*(?:Women’s\s*)?US\s*(.*)$/);
        return match ? {robe: match[1], slippers: match[2], id: option.value, available: !option.disabled} : null;
      });
      if (!pairs.length || pairs.some(pair => !pair)) return;
      const selected = pairs.find(pair => pair.id === combined.value);
      if (!selected) return;
      const controls = document.createElement('div');
      controls.className = 'vv-component-sizes';
      const names = {robe: root.dataset.robeLabel, slippers: root.dataset.slippersLabel};
      for (const kind of ['robe', 'slippers']) {
        const wrapper = document.createElement('div');
        wrapper.className = 'variant-wrapper variant-wrapper--dropdown';
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = `VvComponent-${root.dataset.sectionId}-${kind}`;
        select.dataset.vvComponentSize = kind;
        label.className = 'variant__label';
        label.htmlFor = select.id;
        label.textContent = names[kind];
        for (const value of new Set(pairs.map(pair => pair[kind]))) {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          option.selected = value === selected[kind];
          select.appendChild(option);
        }
        wrapper.append(label, select);
        controls.appendChild(wrapper);
      }
      combined.closest('.variant-wrapper').hidden = true;
      picker.insertBefore(controls, picker.firstChild);
      root.setAttribute('data-vv-component-enhanced', '');
      const updateAvailability = () => controls.querySelectorAll('select').forEach(select => {
        const kind = select.dataset.vvComponentSize;
        const other = kind === 'robe' ? 'slippers' : 'robe';
        const otherValue = controls.querySelector(`[data-vv-component-size="${other}"]`).value;
        Array.from(select.options).forEach(option => {
          option.disabled = !pairs.some(pair => pair[kind] === option.value && pair[other] === otherValue && pair.available);
        });
      });
      updateAvailability();
      controls.addEventListener('change', event => {
        const robe = controls.querySelector('[data-vv-component-size="robe"]').value;
        const slippers = controls.querySelector('[data-vv-component-size="slippers"]').value;
        const pair = pairs.find(item => item.robe === robe && item.slippers === slippers && item.available);
        if (!pair) return;
        combined.value = pair.id;
        root.dataset.vvComponentFocus = event.target.id;
        combined.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceOffDuty(), {once:true});
  else enhanceOffDuty();
  document.addEventListener('shopify:section:load', event => enhanceOffDuty(event.target));
  document.addEventListener('change', async event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-vv-option]')) return;
    const root = event.target.closest('[data-vv-high-variant]');
    const form = root?.closest('form');
    if (!root || !form) return;
    const focusId = root.dataset.vvComponentFocus || event.target.id;
    delete root.dataset.vvComponentFocus;
    const values = [...root.querySelectorAll('[data-vv-option]')].map(select => select.value);
    const button = root.querySelector('[data-vv-high-cart]');
    const status = root.querySelector('[data-vv-selection-status]');
    const prior = requests.get(root);
    prior?.controller.abort();
    const request = { controller: new AbortController() };
    requests.set(root, request);
    root.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.textContent = root.dataset.loading;
    const url = new URL(root.dataset.productUrl, window.location.origin);
    url.searchParams.set('option_values', values.join(','));
    url.searchParams.set('section_id', root.dataset.renderSectionId);
    try {
      const response = await fetch(url, { signal: request.controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Selection unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (requests.get(root) !== request) return;
      const next = html.getElementById(form.getAttribute('id'))?.querySelector('[data-vv-high-variant]');
      const nextId = next?.querySelector('[data-vv-selected-variant]')?.value;
      const nextButton = next?.querySelector('[data-vv-high-cart]');
      if (!nextId || !nextButton || !next.querySelector('[data-vv-option-picker]')) throw new Error('Selection unavailable');
      const nextValues = [...next.querySelectorAll('[data-vv-option]')].map(select => select.value);
      if (values.join(',') !== nextValues.join(',')) throw new Error('Selection mismatch');
      root.querySelector('[data-vv-option-picker]').innerHTML = next.querySelector('[data-vv-option-picker]').innerHTML;
      enhanceOffDuty(form);
      const input = root.querySelector('[data-vv-selected-variant]');
      input.value = nextId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      for (const [sourceSelector, targetId] of [['[data-vv-high-price]', 'ProductPrice-'], ['[data-vv-high-sku]', 'Sku-']]) {
        const content = next.querySelector(sourceSelector)?.textContent ?? '';
        root.querySelector(sourceSelector).textContent = content;
        const target = document.getElementById(targetId + root.dataset.sectionId);
        if (target) target.textContent = content;
      }
      root.querySelector('[data-vv-high-inventory]').textContent = next.querySelector('[data-vv-high-inventory]').textContent;
      button.disabled = nextButton.disabled;
      button.querySelector('span').textContent = nextButton.querySelector('span').textContent;
      status.textContent = '';
      root.removeAttribute('aria-busy');
      if (window.location.pathname === url.pathname) {
        url.searchParams.delete('section_id');
        window.history.replaceState(window.history.state, '', url);
      }
      document.getElementById(focusId)?.focus({ preventScroll: true });
    } catch (error) {
      if (requests.get(root) !== request || error.name === 'AbortError') return;
      console.warn('Vitals & Vibes size selection:', error.message);
      status.textContent = root.dataset.error;
      root.removeAttribute('aria-busy');
      button.disabled = true;
    }
  });
})();
